/* eslint-disable */
// Chakra imports
import {
  Box,
  SimpleGrid,
  useColorModeValue,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect, useState } from "react";

import {
  MdAssignment,
  MdPendingActions,
  MdPriorityHigh,
  MdCheckCircle,
} from "react-icons/md";

import ComplexTable from "views/admin/default/components/ComplexTable";
import TicketCharts from "views/admin/default/components/TicketCharts";
import axiosClient from "../../../api/axiosClient";

export default function UserReports() {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const userId = localStorage.getItem("id_pegawai");

  const [stats, setStats] = useState({
    total_tickets: 0,
    status_summary: {},
    category_summary: {},
    urgency_summary: {},
  });

  const [tickets, setTickets] = useState([]);
  const [urgentTickets, setUrgentTickets] = useState([]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [telegramUrl, setTelegramUrl] = useState(null);

  const fetchTelegramConnect = async () => {
    try {
      const res = await axiosClient.get("/notifications/telegram/connect");
      setTelegramUrl(res.data.url);
      onOpen();
    } catch (error) {
      console.error("Gagal connect telegram", error);
    }
  };

  useEffect(() => {
    const chatId = localStorage.getItem("telegram_chat_id");

    if (!chatId || chatId === "null") {
      fetchTelegramConnect();
    }

    const fetchStats = async () => {
      try {
        const res = await axiosClient.get(`/tickets/statistics`);
        setStats(res.data);
      } catch (error) {
        console.error("Gagal ambil statistik", error);
      }
    };

    if (userId) {
      fetchStats();
    }
  }, [userId]);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const res = await axiosClient.get(`/tickets/track-assigne-me/${userId}`);

        const data = res.data.data || [];
        setTickets(data);

        const urgent = data.filter(
          (t) => t.urgensi?.toLowerCase() === "tinggi"
        );

        setUrgentTickets(urgent);
      } catch (error) {
        console.error("Gagal ambil ticket", error);
      }
    };

    if (userId) {
      fetchTickets();
    }
  }, [userId]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {/* SUMMARY CARDS */}
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 2, lg: 4 }}
        spacing={{ base: "12px", md: "20px" }}
        mb="20px"
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="28px"
                  h="28px"
                  as={MdAssignment}
                  color={brandColor}
                />
              }
            />
          }
          name="Total Ticket Saya"
          value={stats.total_tickets || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="28px"
                  h="28px"
                  as={MdPendingActions}
                  color="orange.400"
                />
              }
            />
          }
          name="Sedang Diproses"
          value={stats.status_summary?.diproses || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="28px"
                  h="28px"
                  as={MdPriorityHigh}
                  color="red.400"
                />
              }
            />
          }
          name="Prioritas Tinggi"
          value={stats.urgency_summary?.tinggi || 0}
        />

        <MiniStatistics
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="28px"
                  h="28px"
                  as={MdCheckCircle}
                  color="green.400"
                />
              }
            />
          }
          name="Selesai"
          value={stats.status_summary?.selesai || 0}
        />
      </SimpleGrid>

      {/* CHARTS */}
      <Box mb="20px">
        <TicketCharts stats={stats} />
      </Box>

      {/* TABLE UTAMA */}
      <Box mb="20px">
        <ComplexTable title="Ticket Aktif Saya" tableData={tickets} />
      </Box>

      {/* TABLE PRIORITAS TINGGI */}
      <Box mb="20px">
        <ComplexTable
          title="Ticket Prioritas Tinggi"
          tableData={urgentTickets}
        />
      </Box>

      {/* TELEGRAM MODAL */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Hubungkan Telegram</ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <Text mb={4}>
              Klik tombol di bawah lalu tekan <b>START</b> di Telegram untuk
              menghubungkan akun kamu.
            </Text>

            {telegramUrl && (
              <Button
                colorScheme="blue"
                w="100%"
                mb={4}
                onClick={() => window.open(telegramUrl, "_blank")}
              >
                Buka Telegram
              </Button>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}